<template>
  <v-container fluid class="pt-0">
    <v-layout wrap>
      <!-- FILTERS -->
      <v-flex xs12>
        <v-card class="mb-3">
            <v-layout wrap>
              <v-flex pa-1>
                <v-menu
                  ref="menu1"
                  :close-on-content-click="false"
                  v-model="menu1"
                  :return-value.sync="dateFrom"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  max-width="290px"
                  min-width="290px"
                >
                  <v-text-field
                    slot="activator"
                    v-model="computedDateFromFormatted"
                    label="Start Date"

                    prepend-icon="mdi-calendar"
                    readonly
                  />
                  <v-date-picker
                    v-model="dateFrom"
                    no-title
                    @input="$refs.menu1.save(dateFrom)"
                    min="2020-01-01"/>
                </v-menu>
              </v-flex>

              <v-flex pa-1>
                <v-menu
                  ref="menu2"
                  :close-on-content-click="false"
                  v-model="menu2"
                  :return-value.sync="dateTo"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  max-width="290px"
                  min-width="290px"
                >
                  <v-text-field
                    slot="activator"
                    v-model="computedDateToFormatted"
                    label="End Date"

                    prepend-icon="mdi-calendar"
                    readonly
                  />
                  <v-date-picker
                    v-model="dateTo"
                    no-title
                    @input="$refs.menu2.save(dateTo)"
                    min="2020-01-01"/>
                </v-menu>
              </v-flex>

              <v-flex pa-1>
                <v-select
                  :items="this.$store.state.stateList"
                  v-model="stateFilter"
                  label="State" />
              </v-flex>

              <v-flex v-if="$store.state.login_type == 'client'" pa-1>
                <v-select
                  :items="this.$store.state.storeTypes"
                  v-model="storeFilter"
                  label="Retailers" />
              </v-flex>

              <v-flex pa-1>
                <v-select
                  :items="this.$store.state.agenciesList" 
                  v-model="agencyFilter"
                  label="Agency"
                  item-text="name" 
                  item-value="name" 
                />
              </v-flex>
            </v-layout>
        </v-card>
      </v-flex>

      <v-flex xs12>
        <v-tabs
          class="card-tabs"
          v-model="activeTab"
          centered
        >
          <v-tab href="#tab-performance">Sales Performance</v-tab>
          <v-tab href="#tab-products">Product Analysis</v-tab>
          <v-tab href="#tab-events">Event & Retailer Insights</v-tab>
        </v-tabs>

        <v-tabs-items v-model="activeTab">
          <v-tab-item value="tab-performance">
            <div class="chart-grid pt-1">
              <!-- WEEKLY SALES LINE -->
              <v-card>
                <v-card-text class="pb-0">
                  <h4 class="title-chart mb-2">Weekly Sales Growth</h4>
                  <p class="body-1 grey--text mb-0 subtitle-chart">Total product sales for all events by week.</p>
                </v-card-text>
                <chart-card
                  :data="salesTrendData"
                  :options="salesTrendOptions"
                  color="secondary"
                  type="Line"
                  class="chart-with-axis-labels"
                >
                  <div class="axis-label y-label">Total Sales</div>
                  <div class="axis-label x-label">Sales Week</div>
                </chart-card>
              </v-card>
              
              <!-- AGENCY SALES BAR -->
              <v-card>
                <v-card-text class="pb-0">
                  <h4 class="title-chart mb-2">Agency Sales</h4>
                  <p class="body-1 grey--text mb-0 subtitle-chart">Total sales per agency aggregated across the calendar period.</p>
                </v-card-text>
                <chart-card
                  :data="agencySalesBarData"
                  :options="agencySalesBarOptions"
                  color="secondary"
                  type="Bar"
                />
              </v-card>

              <!-- TIME OF DAY PERFORMANCE -->
              <v-card>
                <v-card-text class="pb-0">
                  <h4 class="title-chart mb-2">Sales by Time of Day</h4>
                  <p class="body-1 grey--text mb-0 subtitle-chart">Average sales per event vs the event start time.</p>
                </v-card-text>
                <chart-card
                  :data="timeOfDayData"
                  :options="timeOfDayOptions"
                  color="secondary"
                  type="Line"
                >
                  <div class="axis-label y-label">Average Sales </div>
                  <div class="axis-label x-label">Time of Day</div>
                </chart-card>
              </v-card>

              <!-- YEAR OVER YEAR MONTHLY PERFORMANCE -->
              <v-card>
                <v-card-text class="pb-0">
                  <h4 class="title-chart mb-2">Year-over-Year Performance</h4>
                  <p class="body-1 grey--text mb-0 subtitle-chart">Monthly sales comparison for the last 2 years.</p>
                </v-card-text>
                <chart-card
                  :data="yearOverYearData"
                  :options="yearOverYearOptions"
                  color="secondary"
                  type="Line"
                  class="year-over-year-chart"
                >
                  <div class="legend mt-2">
                    <span class="legend-item">
                      <span class="legend-color current-year"></span>
                      {{ new Date().getFullYear() }}
                    </span>
                    <span class="legend-item ml-4">
                      <span class="legend-color last-year"></span>
                      {{ new Date().getFullYear() - 1 }}
                    </span>
                  </div>
                </chart-card>
              </v-card>
            </div>
          </v-tab-item>

          <v-tab-item value="tab-products">
            <div class="chart-grid pt-3">
              <!-- PRODUCT UNITS BAR CHART -->
              <v-card>
                <v-card-text class="pb-0">
                  <h4 class="title-chart mb-2">Product Quantity Sales</h4>
                  <p class="body-1 grey--text mb-0 subtitle-chart">Total units sold (bottles sold / bottles per unit) for the top SKUs.</p>
                </v-card-text>
                <chart-card
                  :data="productUnitsData"
                  :options="productUnitsBarOptions"
                  color="secondary"
                  type="Bar"
                >
                  <div class="axis-label x-label">Number of Units Sold</div>
                </chart-card>
              </v-card>
       
              <!-- PRODUCT SALES PIE CHART -->
              <v-card>
                <v-card-text class="pb-0">
                  <h4 class="title-chart mb-2">Product Earnings</h4>
                  <p class="body-1 grey--text mb-0 subtitle-chart">Top 10 product sales comparison.</p>
                </v-card-text>
                <chart-card
                  :data="productSalesData"
                  :options="productSalesOptions"
                  color="secondary"
                  type="Pie"
                  class="product-sales-pie"
                >
                  <v-card-text class="pt-0">
                    <div class="product-legend">
                      <div 
                        v-for="item in productLegendItems" 
                        :key="item.name"
                        class="product-legend-item"
                      >
                        <div 
                          class="product-legend-color" 
                          :style="{ backgroundColor: item.color }"
                        ></div>
                        <span class="product-legend-text">{{ item.brand }} - {{ item.name }}: ${{ item.total_sales }}</span>
                      </div>
                    </div>
                  </v-card-text>
                </chart-card>
              </v-card>
            </div>
          </v-tab-item>

          <v-tab-item value="tab-events">
            <div class="chart-grid pt-3">
              <!-- CUMULATIVE SAMPLES LINE -->
              <v-card>
                <v-card-text class="pb-0">
                  <h4 class="title-chart mb-2">Total Samples Given</h4>
                  <p class="body-1 grey--text mb-0 subtitle-chart">A cumulative look at samples given in the selected period.</p>
                </v-card-text>
                <chart-card
                  :data="cumulativeSamplesData"
                  :options="cumulativeSamplesOptions"
                  color="secondary"
                  type="Line"
                >
                  <div class="axis-label y-label">Samples Given</div>
                  <div class="axis-label x-label">Sales Week</div>
                </chart-card>
              </v-card>

              <!-- SAMPLES PER SALE SCATTER -->
              <v-card>
                <v-card-text class="pb-0">
                  <h4 class="title-chart mb-2">Event Samples vs. Sales</h4>
                  <p class="body-1 grey--text mb-0 subtitle-chart">Correlation between samples given and total sales per event.</p>
                </v-card-text>
                <chart-card
                  :data="eventSamplesVsSalesData"
                  :options="eventSamplesVsSalesOptions"
                  color="secondary"
                  type="Line"
                  class="scatter-chart"
                >
                  <div class="axis-label y-label">Total Sales</div>
                  <div class="axis-label x-label">Number of Samples Distributed Per Event</div>
                </chart-card>
              </v-card>

              <!-- RETAILER AVERAGE SALES -->
              <v-card>
                <v-card-text class="pb-0">
                  <h4 class="title-chart mb-2">Retailer Average Sales</h4>
                  <p class="body-1 grey--text mb-0 subtitle-chart">Average sales total per event for each retailer.</p>
                </v-card-text>
                <chart-card
                  :data="retailerAvgSalesData"
                  :options="retailerAvgSalesOptions"
                  color="secondary"
                  type="Bar"
                />
              </v-card>
            </div>
          </v-tab-item>
        </v-tabs-items>
      </v-flex>

    </v-layout>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex'
import ChartCard from '@/components/material/ChartCard'

export default {
  name: 'Insights',
  components: {
    ChartCard
  },
  data() {
    return {
      weeklySalesData: null,
      agencyBarData: null,
      cumulativeSamples: null,
      eventPerformanceRawData: null,
      timeOfDayRawData: null,
      yearOverYearRawData: null,
      productSalesRawData: null,
      productUnitsRawData: null,
      retailerAvgSalesRawData: null,
      menu1: false,
      menu2: false,
      activeTab: null
    }
  },
  computed: {
    dateFrom: {
      get () {
        return this.$store.state.dateFrom
      },
      set (value) {
        this.$store.commit('setDateFrom', value)
      }
    },

    dateTo: {
      get () {
        return this.$store.state.dateTo
      },
      set (value) {
        this.$store.commit('setDateTo', value)
      }
    },

    stateFilter: {
      get () {
        return this.$store.state.stateFilter
      },
      set (value) {
        this.$store.commit('setStateFilter', value)
      }
    },

    storeFilter: {
      get () {
        return this.$store.state.storeFilter
      },
      set (value) {
        this.$store.commit('setStoreFilter', value)
      }
    },

    agencyFilter: {
      get () {
        return this.$store.state.agencyFilter
      },
      set (value) {
        this.$store.commit('setAgencyFilter', value)
      }
    },

    computedDateFromFormatted () {
      return this.formatDate(this.dateFrom)
    },

    computedDateToFormatted () {
      return this.formatDate(this.dateTo)
    },

    salesTrendData() {
      if (!this.weeklySalesData) return {}
      return {
        labels: this.weeklySalesData.labels,
        series: [this.weeklySalesData.values]
      }
    },

    salesTrendOptions() {
      return {
        axisY: {
          labelInterpolationFnc: function(value) {
            return value != null ? '$' + value.toLocaleString() : '$0'
          },
        },
        axisX: {
          labelInterpolationFnc: function(value, index) {
            return index % 2 === 0 ? value : null
          },
        },
        lineSmooth: true,
        showPoint: true,
        fullWidth: true,
        chartPadding: {
          top: 30,
          right: 40,
          bottom: 50,
          left: 70
        }
      }
    },

    agencySalesBarData() {
      if (!this.agencyBarData) return {}
      return {
        labels: this.agencyBarData.labels,
        series: [this.agencyBarData.values]
      }
    },

    agencySalesBarOptions() {
      return {
        axisY: {
          labelInterpolationFnc: function(value) {
            return value != null ? '$' + value.toLocaleString() : '$0'
          },
        },
        axisX: {
          labelInterpolationFnc: function(value) {
            const maxLength = 15
            return value.length > maxLength ? value.slice(0, maxLength) + '...' : value
          },
        },
        seriesBarDistance: 10,
        fullWidth: true,
        chartPadding: {
          top: 40,
          right: 20,
          bottom: 20,
          left: 30
        },
      }
    },

    cumulativeSamplesData() {
      if (!this.cumulativeSamples) return {}
      return {
        labels: this.cumulativeSamples.labels,
        series: [this.cumulativeSamples.values]
      }
    },

    cumulativeSamplesOptions() {
      return {
        axisY: {
          labelInterpolationFnc: function(value) {
            return value != null ? + value : '0'
          },
        },
        axisX: {
          labelInterpolationFnc: function(value) {
            return value 
          },
        },
        lineSmooth: true,
        showPoint: true,
        fullWidth: true,
        chartPadding: {
          top: 30,
          right: 35,
          bottom: 50,
          left: 70
        }
      }
    },

    eventSamplesVsSalesData() {
      if (!this.eventPerformanceRawData) return { series: [], labels: [] }
      
      const sortedData = [...this.eventPerformanceRawData].sort((a, b) => a.samples - b.samples)
      
      return {
        labels: sortedData.map(event => event.samples),
        series: [sortedData.map(event => parseFloat(event.total_sales))]
      }
    },

    eventSamplesVsSalesOptions() {
      return {
        axisX: {
          labelInterpolationFnc: function(value, index) {
             return index % 8 === 0 ? value : null 
          },
        },
        axisY: {
          labelInterpolationFnc: function(value) { return '$' + value.toLocaleString() },
        },
        showLine: false,
        showPoint: true,
        fullWidth: true,
        chartPadding: {
          top: 30,
          right: 30,
          bottom: 50,
          left: 60
        },
        // plugins: [
        //   Chartist.plugins.tooltip()
        // ]
      }
    },

    timeOfDayData() {
      if (!this.eventPerformanceRawData) return {}
      
      const timeData = {}
      this.eventPerformanceRawData.forEach(event => {
        const timeKey = event.time_start.substring(0, 5)
        if (!timeData[timeKey]) {
          timeData[timeKey] = { total_sales: 0, events: 0 }
        }
        timeData[timeKey].total_sales += parseFloat(event.total_sales)
        timeData[timeKey].events += 1
      })

      const sortedTimes = Object.keys(timeData).sort()
      const labels = sortedTimes.map(time => {
        const [hour, minute] = time.split(':')
        const h = parseInt(hour)
        const meridian = h >= 12 ? 'PM' : 'AM'
        const displayHour = h === 0 ? 12 : h > 12 ? h - 12 : h
        const displayMinute = minute === '00' ? '' : `:${minute}`
        return `${displayHour}${displayMinute}${meridian}`
      })
      const values = sortedTimes.map(time => timeData[time].total_sales / timeData[time].events)

      return {
        labels,
        series: [values]
      }
    },

    timeOfDayOptions() {
      return {
        axisX: {
          labelInterpolationFnc: function(value, index) {
             return index % 2 === 0 ? value : null 
          },
        },
        axisY: {
          labelInterpolationFnc: function(value, index) { 
            return index % 2 === 0 ?'$' + Math.round(value).toLocaleString() : null 
          },
        },
        lineSmooth: true,
        showPoint: true,
        fullWidth: true,
        chartPadding: {
          top: 30,
          right: 40,
          bottom: 50,
          left: 70
        }
      }
    },

    yearOverYearData() {
      if (!this.yearOverYearRawData) return {}
      
      const currentYear = new Date().getFullYear()
      const lastYear = currentYear - 1
      
      const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
      
      const currentYearData = {}
      const lastYearData = {}
      
      this.yearOverYearRawData.forEach(item => {
        if (item.year === currentYear) {
          currentYearData[item.month] = item
        } else if (item.year === lastYear) {
          lastYearData[item.month] = item
        }
      })
      
      // Get all unique months that have data
      const availableMonths = [...new Set(this.yearOverYearRawData.map(item => item.month))].sort((a, b) => a - b)
      
      return {
        labels: availableMonths.map(month => monthNames[month - 1]),
        series: [
          availableMonths.map(month => currentYearData[month] ? parseFloat(currentYearData[month].monthly_sales) : 0),
          availableMonths.map(month => lastYearData[month] ? parseFloat(lastYearData[month].monthly_sales) : 0)
        ]
      }
    },

    yearOverYearOptions() {
      return {
        axisX: {
          labelInterpolationFnc: function(value) {
            return value
          },
        },
        axisY: {
          labelInterpolationFnc: function(value) {
            return '$' + Math.round(value).toLocaleString()
          },
        },
        lineSmooth: true,
        showPoint: true,
        fullWidth: true,
        chartPadding: {
          top: 30,
          right: 40,
          bottom: 20,
          left: 30
        },
      }
    },

    productSalesData() {
      if (!this.productSalesRawData) return {}
      
      const productData = this.productSalesRawData
      return {
        labels: productData.map(item => {
          const maxLength = 25
          return item.name.length > maxLength ? item.name.slice(0, maxLength) + '...' : item.name
        }),
        series: productData.map(item => parseFloat(item.total_sales))
      }
    },

    productSalesOptions() {
      return {
        showLabel: true,
        chartPadding: 30,
        labelInterpolationFnc: (value, index) => {
          if (!this.productSalesRawData || this.productSalesRawData.length === 0) return ''
          
          const total = this.productSalesRawData.reduce((sum, item) => {
            return sum + parseFloat(item.total_sales || 0)
          }, 0)
          
          const currentValue = parseFloat(this.productSalesRawData[index].total_sales || 0)
          const percentage = total > 0 ? ((currentValue / total) * 100) : 0
          
          return `${Math.round(percentage)}%`
        }
      }
    },

    productLegendItems() {
      if (!this.productSalesRawData) return []
      
      const colors = ['#CAA2DD', '#9C27B0', '#673AB7', '#3F51B5', '#2196F3', '#03DAC6', '#4CAF50', '#8BC34A', '#CDDC39', '#FFC107']
      
      return this.productSalesRawData.map((item, index) => ({
        name: item.name,
        brand: item.brand,
        total_sales: parseFloat(item.total_sales).toFixed(2),
        color: colors[index % colors.length]
      }))
    },

    productLegendUnitsItems() {
      if (!this.productUnitsRawData) return []
      
      const colors = ['#CAA2DD', '#9C27B0', '#673AB7', '#3F51B5', '#2196F3', '#03DAC6', '#4CAF50', '#8BC34A', '#CDDC39', '#FFC107']
      
      return this.productUnitsRawData.map((item, index) => ({
        name: item.name,
        color: colors[index % colors.length]
      }))
    },

    productUnitsData() {
      if (!this.productUnitsRawData) return {}
      
      const productData = this.productUnitsRawData
      return {
        labels: productData.map(item => {
          const brandName = item.brand
          const productName = item.name
          
          // Calculate available space for product name
          const maxTotalLength = 40
          const separatorLength = 2 
          const availableForProduct = maxTotalLength - brandName.length - separatorLength
          
          let truncatedProduct = productName
          if (availableForProduct > 0 && productName.length > availableForProduct) {
            truncatedProduct = productName.slice(0, availableForProduct - 3) + '...'
          }
          
          return `${brandName} - ${truncatedProduct}`
        }),
        series: [productData.map(item => parseFloat(item.units))]
      }
    },

    productUnitsBarOptions() {
      return {
        horizontalBars: true,
        axisX: {
          labelInterpolationFnc: function(value, index) {
            return index % 2 === 0 ? (value != null ? Math.round(value) : '0') : null
          },
        },
        axisY: {
          labelInterpolationFnc: function(value) {
            return value
          },
        },
        seriesBarDistance: 10,
        fullWidth: true,
        chartPadding: {
          top: 20,
          right: 35,
          bottom: 50,
          left: 60
        },
      }
    },

    retailerAvgSalesData() {
      if (!this.retailerAvgSalesRawData) return {}
      
      return {
        labels: this.retailerAvgSalesRawData.map(item => {
          const maxLength = 20
          return item.name.length > maxLength ? item.name.slice(0, maxLength) + '...' : item.name
        }),
        series: [this.retailerAvgSalesRawData.map(item => parseFloat(item.avg_sale))]
      }
    },

    retailerAvgSalesOptions() {
      return {
        axisY: {
          labelInterpolationFnc: function(value) {
            return '$' + Math.round(value).toLocaleString()
          },
        },
        axisX: {
          labelInterpolationFnc: function(value) {
            const maxLength = 15
            return value.length > maxLength ? value.slice(0, maxLength) + '...' : value
          },
        },
        seriesBarDistance: 10,
        fullWidth: true,
        chartPadding: {
          top: 30,
          right: 30,
          bottom: 20,
          left: 20
        },
      }
    },

  },

  async mounted() {
    await this.getFilters()
    await this.reloadData()
  },

  watch: {
    '$store.state.dateFrom'() { this.reloadData() },
    '$store.state.dateTo'() { this.reloadData() },
    '$store.state.stateFilter'() { this.reloadData() },
    '$store.state.storeFilter'() { this.reloadData() },
    '$store.state.agencyFilter'() { this.reloadData() },
    // Force chart redraw when tab changes
    activeTab() {
      this.$nextTick(() => {
        // Trigger multiple resize events to ensure all charts update
        setTimeout(() => {
          window.dispatchEvent(new Event('resize'))
        }, 100)
        setTimeout(() => {
          window.dispatchEvent(new Event('resize'))
        }, 300)
      })
    }
  },

  methods: {
    ...mapActions([
      'fetchSalesTrends', 
      'fetchAgencyBarData', 
      'fetchCumulativeSamples', 
      'fetchEventPerformance', 
      'fetchYearOverYearData', 
      'fetchProductSalesData',
      'fetchProductUnitsData',
      'fetchRetailerSalesAvg'
    ]),

    async reloadData() {
      await this.loadSalesData()
      await this.loadAgencyBarData()
      await this.loadCumulativeSamplesData()
      await this.loadEventPerformanceData()
      await this.loadYearOverYearData()
      await this.loadProductSalesData()
      await this.loadProductUnitsData()
      await this.loadRetailerAvgSalesData()
    },

    formatDate (date) {
      if (!date) return null
      const [year, month, day] = date.split('-')
      return `${month}/${day}/${year}`
    },

    getFilters: function () {
      this.$store.dispatch('get_storeTypes', { dateStart: this.$store.state.dateFrom, dateEnd: this.$store.state.dateTo })
      this.$store.dispatch('get_agencies')
    },

    async loadSalesData() {
      try {
        const rawData = await this.fetchSalesTrends({
          startDate: this.$store.state.dateFrom,
          endDate: this.$store.state.dateTo
        })

        this.weeklySalesData = {
          labels: rawData.map(item => `Wk \n ${item.sales_week % 100}`),
          values: rawData.map(item => parseFloat(item.weekly_total))
        }
      } catch (error) {
        console.error('Error loading sales data:', error)
        // Fallback mock data
        this.weeklySalesData = {
          labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
          values: [45000, 52000, 48000, 61000, 58000, 67000, 72000, 69000, 74000, 81000, 77000, 89000]
        }
      }
    },

    async loadAgencyBarData() {
      try {
        const agencyData = await this.fetchAgencyBarData({
          startDate: this.$store.state.dateFrom,
          endDate: this.$store.state.dateTo
        })

        this.agencyBarData = {
          labels: agencyData.map(item => item.agency_name),
          values: agencyData.map(item => parseFloat(item.total_sales))
        }
      } catch (error) {
        console.error('Error loading agency bar data:', error)
        // Fallback mock data
        this.agencyBarData = {
          labels: ['RFE', 'Integro Mktg', 'Diamond Girl', 'Next Level Mktg', 'Flow Wine Group', 'Enthuse Marketing', 'Ev0lver', 'Brand Socialite', 'Social Sampling'],
          values: [45000, 52000, 48000, 61000, 58000, 67000, 72000, 69000, 74000]
        }
      }
    },


    async loadCumulativeSamplesData() {
      try {
        const samplesData = await this.fetchCumulativeSamples({
          startDate: this.$store.state.dateFrom,
          endDate: this.$store.state.dateTo
        })

        this.cumulativeSamples = {
          labels: samplesData.map(item => `Wk \n ${item.sales_week % 100}`),
          values: samplesData.map(item => item.cumulative_samples)
        }
      } catch (error) {
        console.error('Error loading cumulative samples data:', error)
        // Fallback mock data
        this.cumulativeSamples = {
          labels: ['Wk1', 'Wk2', 'Wk3', 'Wk4', 'Wk5', 'Wk6', 'Wk7', 'Wk8', 'Wk9'],
          values: [220, 340, 567, 795, 1200, 1350, 1521, 1699, 1941]
        }
      }
    },

    async loadEventPerformanceData() {
      try {
        const rawData = await this.fetchEventPerformance({
          startDate: this.$store.state.dateFrom,
          endDate: this.$store.state.dateTo,
          state: this.$store.state.stateFilter,
          storeType: this.$store.state.storeFilter,
          agency: this.$store.state.agencyFilter
        })
        this.eventPerformanceRawData = rawData
      } catch (error) {
        console.error('Error loading event performance data:', error)
        // Fallback mock data
        this.eventPerformanceRawData = [
          { event_id: 1, samples: 50, total_sales: 300, time_start: "10:00" },
          { event_id: 2, samples: 75, total_sales: 450, time_start: "12:00" },
          { event_id: 3, samples: 100, total_sales: 600, time_start: "14:00" },
          { event_id: 4, samples: 60, total_sales: 320, time_start: "16:00" },
          { event_id: 5, samples: 120, total_sales: 580, time_start: "11:00" },
          { event_id: 6, samples: 85, total_sales: 510, time_start: "15:00" },
          { event_id: 7, samples: 150, total_sales: 750, time_start: "13:00" },
        ]
      }
    },

    async loadYearOverYearData() {
      try {
        const rawData = await this.fetchYearOverYearData({
          startDate: this.$store.state.dateFrom,
          endDate: this.$store.state.dateTo,
          state: this.$store.state.stateFilter,
          storeType: this.$store.state.storeFilter,
          agency: this.$store.state.agencyFilter
        })
        this.yearOverYearRawData = rawData
      } catch (error) {
        console.error('Error loading year-over-year data:', error)
        // Fallback mock data
        const currentYear = new Date().getFullYear()
        const lastYear = currentYear - 1
        this.yearOverYearRawData = [
          { year: currentYear, month: 1, monthly_sales: 45000, demo_count: 12 },
          { year: currentYear, month: 2, monthly_sales: 52000, demo_count: 15 },
          { year: currentYear, month: 3, monthly_sales: 48000, demo_count: 11 },
          { year: currentYear, month: 4, monthly_sales: 61000, demo_count: 18 },
          { year: currentYear, month: 5, monthly_sales: 58000, demo_count: 16 },
          { year: currentYear, month: 6, monthly_sales: 67000, demo_count: 20 },
          { year: lastYear, month: 1, monthly_sales: 42000, demo_count: 10 },
          { year: lastYear, month: 2, monthly_sales: 48000, demo_count: 13 },
          { year: lastYear, month: 3, monthly_sales: 45000, demo_count: 9 },
          { year: lastYear, month: 4, monthly_sales: 55000, demo_count: 15 },
          { year: lastYear, month: 5, monthly_sales: 53000, demo_count: 14 },
          { year: lastYear, month: 6, monthly_sales: 62000, demo_count: 17 }
        ]
      }
    },

    async loadProductSalesData() {
      try {
        const response = await this.fetchProductSalesData({
          startDate: this.$store.state.dateFrom,
          endDate: this.$store.state.dateTo
        })

        this.productSalesRawData = response.slice(0, 10)
      } catch (error) {
        console.error('Error loading product sales data:', error)
        // Fallback mock data
        this.productSalesRawData = [
          { name: 'Cantera Negra Tequila', total_sales: '227.96' },
          { name: 'Bib and Tucker Bourbon', total_sales: '207.96' },
          { name: 'The Calling Chardonnay', total_sales: '181.20' },
          { name: 'Josh Cellars Prosecco', total_sales: '161.72' },
          { name: 'Bib and Tucker 6yr', total_sales: '155.97' }
        ]
      }
    },

    async loadProductUnitsData() {
      try {
        const response = await this.fetchProductUnitsData({
          startDate: this.$store.state.dateFrom,
          endDate: this.$store.state.dateTo
        })

        this.productUnitsRawData = response
      } catch (error) {
        console.error('Error loading product units data:', error)
        // Fallback mock data
        this.productUnitsRawData = [
          { name: 'Cantera Negra Tequila', units: '227' },
          { name: 'Bib and Tucker Bourbon', units: '207' },
          { name: 'The Calling Chardonnay', units: '181' },
          { name: 'Josh Cellars Prosecco', units: '161' },
          { name: 'Bib and Tucker 6yr', units: '155' }
        ]
      }
    },

    async loadRetailerAvgSalesData() {
      try {
        const response = await this.fetchRetailerSalesAvg({
          startDate: this.$store.state.dateFrom,
          endDate: this.$store.state.dateTo
        })

        this.retailerAvgSalesRawData = response
      } catch (error) {
        console.error('Error loading retailer average sales data:', error)
        // Fallback mock data
        this.retailerAvgSalesRawData = [
          { name: 'Total Wine', avg_sale: 650.25 },
          { name: 'HEB', avg_sale: 485.75 },
          { name: 'Kroger', avg_sale: 412.30 },
          { name: 'ABSCO', avg_sale: 380.90 },
          { name: 'Specs', avg_sale: 295.50 }
        ]
      }
    },
  }
}
</script>

<style>

  .ct-bar, .ct-point, .ct-line{
    stroke: #FFFF !important;
  }

  .v-card--material-chart .v-card__text:empty {
    display: none !important
  }

  .chart-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 20px;
    margin-top: 16px;
  }

  @media (max-width: 960px) {
    .chart-grid {
      grid-template-columns: 1fr;
    }
  }

  /* SCATTER PLOT */
  .scatter-chart .ct-point {
    stroke-width: 6.5px !important;
  }

  /* YEAR-OVER-YEAR */
  .legend {
    display: flex;
    align-items: center;
  }

  .legend-item {
    display: flex;
    align-items: center;
    font-size: 14px;
  }

  .legend-color {
    width: 26px;
    height: 8px;
    margin-right: 8px;
    border-radius: 2px;
    border: 1px solid #000;
  }

  .current-year {
    background-color: #CAA2DD;
  }

  .last-year {
    background-color: #FFF;
  }

  .year-over-year-chart .ct-chart-line .ct-series.ct-series-a .ct-line,
  .year-over-year-chart .ct-chart-line .ct-series.ct-series-a .ct-point {
    stroke: #CAA2DD !important;
    stroke-width: 4px !important;
  }

  .year-over-year-chart .ct-chart-line .ct-series.ct-series-a .ct-point {
    stroke-width: 10px !important;
  }

  .year-over-year-chart .ct-chart-line .ct-series.ct-series-b .ct-line,
  .year-over-year-chart .ct-chart-line .ct-series.ct-series-b .ct-point {
    stroke: #FFF !important;
    stroke-width: 4px !important;
  }

  .year-over-year-chart .ct-chart-line .ct-series.ct-series-b .ct-point {
    stroke-width: 10px !important;
  }

  /* PRODUCT SALES PIE */
  .ct-chart-pie .ct-label {
    font-size: 14px !important;
    font-weight: bold !important;
    fill: #FFF !important;
  }

  .ct-chart-pie .ct-series-a .ct-slice-pie { fill: #CAA2DD !important; }
  .ct-chart-pie .ct-series-b .ct-slice-pie { fill: #9C27B0 !important; }
  .ct-chart-pie .ct-series-c .ct-slice-pie { fill: #673AB7 !important; }
  .ct-chart-pie .ct-series-d .ct-slice-pie { fill: #3F51B5 !important; }
  .ct-chart-pie .ct-series-e .ct-slice-pie { fill: #2196F3 !important; }
  .ct-chart-pie .ct-series-f .ct-slice-pie { fill: #03DAC6 !important; }
  .ct-chart-pie .ct-series-g .ct-slice-pie { fill: #4CAF50 !important; }
  .ct-chart-pie .ct-series-h .ct-slice-pie { fill: #8BC34A !important; }
  .ct-chart-pie .ct-series-i .ct-slice-pie { fill: #CDDC39 !important; }
  .ct-chart-pie .ct-series-j .ct-slice-pie { fill: #FFC107 !important; }

  .product-legend {
    display: flex;
    flex-direction: column;
    gap: 8px;
    max-height: 145px;
    overflow-y: scroll;
  }

  .product-legend-item {
    display: flex;
    align-items: center;
  }

  .product-legend-color {
    width: 12px;
    height: 12px;
    border-radius: 2px;
    margin-right: 6px;
    flex-shrink: 0;
  }

  .product-legend-text {
    font-size: 16px;
    color: #000 !important;
    line-height: 1.2;
  }

    .product-legend-units {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .product-legend-units-item {
    display: flex;
    align-items: center;
  }

  .ct-label {
    font-size: 15px !important;
  }

  .v-tabs .v-tabs__item {
    font-size: 16px;
  }

  .v-tabs__div {
    color: #000 !important;
  }

  .title-chart {
    font-weight: bold !important;
    color: #333 !important;
    font-size: 1.5rem !important;
  }

  .subtitle-chart {
    color: #333 !important;
  }

  .body-1 {
    font-size: 18px !important;
  }
  .ct-label {
    opacity: 1 !important;
  }

  /* AXIS STYLES */
  .chart-with-axis-labels {
    position: relative;
  }

  .axis-label {
    position: absolute;
    font-size: 20px;
    color: #FFF;
    pointer-events: none;
    z-index: 10;
  }

  .y-label {
    left: -15px;
    top: 45%;
    transform: rotate(-90deg);
    transform-origin: center;
    white-space: nowrap;
  }

  .x-label {
    bottom: 50px;
    left: 50%;
    transform: translateX(-50%);
    white-space: nowrap;
  }
</style>